export default "__VITE_ASSET__0066a0bb__"